const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.92 10C34.8 11.78 34.5 13.52 34.02 15.18L36.42 17.58C37.24 15.18 37.76 12.64 37.94 10H34.92ZM15.2 34.04C13.5 34.52 11.76 34.82 10 34.94V37.92C12.64 37.74 15.18 37.22 17.6 36.42L15.2 34.04ZM33 6H40C41.1 6 42 6.9 42 8C42 26.78 26.78 42 8 42C6.9 42 6 41.1 6 40V33.02C6 31.92 6.9 31.02 8 31.02C10.48 31.02 12.9 30.62 15.14 29.88C15.34 29.8 15.56 29.78 15.76 29.78C16.28 29.78 16.78 29.98 17.18 30.36L21.58 34.76C27.24 31.86 31.88 27.24 34.76 21.58L30.36 17.18C29.8 16.62 29.64 15.84 29.86 15.14C30.6 12.9 31 10.5 31 8C31 6.9 31.9 6 33 6Z",
    fill: props.fill
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.ae39d64fc300c186af82da522223adb1.svg";
export { ForwardRef as ReactComponent };